import { render, staticRenderFns } from "./GoogleLoginVerify.vue?vue&type=template&id=59786b8a"
import script from "./GoogleLoginVerify.vue?vue&type=script&lang=js"
export * from "./GoogleLoginVerify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59786b8a')) {
      api.createRecord('59786b8a', component.options)
    } else {
      api.reload('59786b8a', component.options)
    }
    module.hot.accept("./GoogleLoginVerify.vue?vue&type=template&id=59786b8a", function () {
      api.rerender('59786b8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/GoogleLoginVerify.vue"
export default component.exports